import { AdminPageHeader } from '@/components/patterns/admin-page'
import TerminalForm from '@/components/forms/TerminalForm'
import { locationFilters, locationQueries } from '@/lib/services/locations/locations.query'
import { assertNotSalesDemoOrganization } from '@/lib/services/sales-demos/sales-demos.guard'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { CreditCard } from 'lucide-react'
import {
  terminalSearchSchema,
  assertTerminalAccountAccess,
} from '@/lib/services/terminals/terminals.schema'

const filters = locationFilters().get()

export const Route = createFileRoute('/_authenticated/$orgId/settings/terminals/create')({
  component: RouteComponent,
  validateSearch: terminalSearchSchema,
  loaderDeps: ({ search }) => ({
    accountContext: search.accountContext,
    sourceReaderId: search.sourceReaderId,
  }),
  loader: ({ context, params, deps = {} }) => {
    if (!context.ability?.can('create', 'terminals')) throw notFound()
    assertTerminalAccountAccess(context.ability, deps.accountContext)
    if (deps.accountContext === 'target' && !deps.sourceReaderId) throw notFound()

    assertNotSalesDemoOrganization(context.queryClient, params.orgId)
    void context.queryClient.ensureQueryData(
      locationQueries.index({ organizationId: params.orgId, filters })
    )
    return { isReadOnly: false }
  },
})

function RouteComponent() {
  const { accountContext, sourceReaderId } = Route.useSearch()
  return (
    <div className="max-w-4xl space-y-4">
      <AdminPageHeader icon={CreditCard} title="Register New Terminal" />
      <TerminalForm
        key={`${accountContext}:${sourceReaderId}`}
        accountContext={accountContext}
        sourceReaderId={sourceReaderId}
      />
    </div>
  )
}
